import '../css/form2.css'
import visa from '../images/visa.png'
import chip from '../images/chip.png'
import { useState } from 'react';
import axios from "axios"
import { useNavigate } from 'react-router-dom';

export default function Addcards(){
    const Navigate=useNavigate();
    const [user,setUser]=useState({})
    const [usercard,setUsercard]=useState({})
    const [username,setUsername]=useState({})
    const [userexpirymm,setUserexpirymm]=useState({})
    const [userexpiryyy,setUserexpiryyy]=useState({})
    const [usercvv,setUsercvv]=useState({})



const handleSubmit=(e)=> { // Once the form has been submitted, this function will post to the backend
    e.preventDefault();
    

const newNote={
    card:usercard.card,
  cardnumber:user.cardnumber,
  expirymm:userexpirymm.expirymm,
  expiryyy:userexpiryyy.expiryyy,
  name:username.name,
  cvv:usercvv.cvv

}
console.log(newNote)
if(newNote){

    axios.post("https://storcarrd.herokuapp.com/posts", newNote,{
     method: "POST",
     headers: {
       Accept: "application/json",
       "Content-Type": "application/json",
       "authentication": localStorage.getItem("token"),
       "auth":localStorage.getItem("email")
     },
   })
    .then(res=>{
     //  console.log(res.status)
     alert("posted successfully")
     if(res.status===200){
         // console.log("hiiiiihii")
          Navigate("/home")
     } 
   })
   }
   else{
   alert("invalid input")
   }
   
}

    return(
        <>
<div className="container" id="dfr">

<div className="card-container">

    <div className="front">
        <div className="image">
            <img src={chip} alt=""/>
            <img src={visa} alt=""/>
        </div>
        <div className="card-number-box" contenteditable="true" placeholder="**** **** **** ****">{user.cardnumber}</div>
        <div className="flexbox">
            <div className="box">
                <span>card holder</span>
                <div className="card-holder-name" contenteditable="true" placeholder="full name">{username.name}</div>
            </div>
            <div className="box">
                <span>expires</span>
                <div className="expiration">
                    <span className="exp-month" contenteditable="true" placeholder="mm">{userexpirymm.expirymm}</span>
                    <span>/</span>
                    <span className="exp-year" contenteditable="true" placeholder="yy">{userexpiryyy.expiryyy}</span>
                </div>
            </div>
        </div>
    </div>

    <div className="back">
        <div className="stripe"></div>
        <div className="box">
            <span>cvv</span>
            <div className="cvv-box" contenteditable="true" placeholder="****">{usercvv.cvv}</div>
            <img src={visa} alt=""/>
        </div>
    </div>

</div>

<form action="" onSubmit={handleSubmit}>
<div className="inputBox">
        <span>card Type</span>
        <select name="card" id="" className="year-input" onChange={(e)=>setUsercard({...usercard,card:e.target.value})} required >
                <option value="" selected disabled>CARD</option>
                <option value="DEBIT CARD">DEBIT CARD</option>
                <option value="CREDIT CARD">CREDIT CARD</option>
                </select>
    </div>
    <div className="inputBox">
        <span>card number</span>
        <input type="text" maxLength="16" className="card-number-input" name="cardnumber" pattern="[0-9]*" inputmode="numeric" onChange={(e)=>setUser({...user,cardnumber:e.target.value})} required/>
    </div>
    <div className="inputBox">
        <span>card holder</span>
        <input type="text" className="card-holder-input"  name="name" onChange={(e)=>setUsername({...username,name:e.target.value})} required />
    </div>
    <div className="flexbox">
        <div className="inputBox">
            <span>expiration mm</span>
            <select name="expirymm" id="" className="month-input"   onChange={(e)=>setUserexpirymm({...userexpirymm,expirymm:e.target.value})} required  >
                <option value="" selected disabled>month</option>
                <option value="01">01</option>
                <option value="02">02</option>
                <option value="03">03</option>
                <option value="04">04</option>
                <option value="05">05</option>
                <option value="06">06</option>
                <option value="07">07</option>
                <option value="08">08</option>
                <option value="09">09</option>
                <option value="10">10</option>
                <option value="11">11</option>
                <option value="12">12</option>
            </select>
        </div>
        <div className="inputBox">
            <span>expiration yy</span>
            <select name="expiryyy" id="" className="year-input"  onChange={(e)=>setUserexpiryyy({...userexpiryyy,expiryyy:e.target.value})}  required >
                <option value="" selected disabled>year</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
                <option value="2027">2027</option>
                <option value="2028">2028</option>
                <option value="2029">2029</option>
                <option value="2030">2030</option>
            </select>
        </div>
        <div className="inputBox" >
            <span>cvv</span>
            <input type="text"    maxlength="4" className="cvv-input" name="cvv"   pattern="[0-9]*" inputmode="numeric"   onChange={(e)=>setUsercvv({...usercvv,cvv:e.target.value})}  required />
        </div>
    </div>
    <input type="submit" value="submit" className="submit-btn"/>
</form>

</div>    
        </>
    )
}